import { useState, useEffect } from 'react';

import useFetch from 'use-http';

import { API_ROUTES } from '../../constants';

import {TPartnerDetailsData, TAPIResponsePartnerDetails} from './partner-details.types';

export const useAPIFetchPartnerDetails = (id: string): TAPIResponsePartnerDetails => {
  const [responseData, setResponseData] = useState<TPartnerDetailsData>({} as TPartnerDetailsData);
  const { get, response, loading, error } = useFetch(API_ROUTES.APPLICATIONS);

  async function fetchPartnerDetails(applicationId: string): Promise<void> {
    const {data} = await get(`${applicationId}/partner-details`);

    setResponseData(data ? data : {});
  }

  useEffect(() => { fetchPartnerDetails(id) }, []);

  return {
    loading,
    error,
    data: responseData,
    loaded: response.ok,
    fetchPartnerDetails,
  };
};


